import React, { useEffect, useRef, useState } from 'react'
import { createRoot } from 'react-dom/client'
import { loadCaptchaEnginge, LoadCanvasTemplate, validateCaptcha } from 'react-simple-captcha'
import './ContactForm.scss'
import FormsService from 'src/services/FormsService'
import FormError from './FormError'
import ModalFormResponse from '../components/modals/ModalFormResponse'


const ContactForm = ({ submitButton = 'Send', sendDataToParent }) => {
  const isIndustries = window.location.pathname
  const [errors, setErrors] = useState({})
  const [formSuccess, setFormSuccess] = useState(false)
  const [inputFields, setInputFields] = useState({
    email: '',
    name: '',
    city: '',
    phone: '',
    message: '',
    termsConsent: false,
    captcha: ''
  })
  const [isChecked, setIsChecked] = useState(false)
  const [submitting, setSubmitting] = useState(false)
  const service = {
    forms: new FormsService()
  }
  const modalMessage = <>Thank you for getting in touch.<br /><br />We appreciate you contacting us. One of our colleagues will get back in touch with you soon.</>
  const modalTitle = <>Successfully sent <i className="fa fa-check" aria-hidden="true"></i></>

  useEffect(() => {
    !formSuccess ? loadCaptchaEnginge(6) : null
    finishSubmit()
  }, [errors])

  const finishSubmit = async () => {
    if (submitting) {
      //success form submission
      if (Object.keys(errors).length === 0) {
        service.forms.contact(inputFields).then((resp: any) => {
          setFormSuccess(true)
          setSubmitting(false)
          setInputFields({
            email: '',
            name: '',
            city: '',
            phone: '',
            message: '',
            termsConsent: false,
            captcha: ''
          })
          setIsChecked(false)
          createRoot(document.getElementById('modal-responses')).render(<ModalFormResponse status={true} message={modalMessage} title={modalTitle} />)
          //error api
        }).catch(error => {
          console.log('ERR: ', error)
          setSubmitting(false)
        })
        //error mandatory fields
      } else if (Object.keys(errors).length > 0 && submitting) {
        setSubmitting(false)
        document.querySelector('#js-scroll-anchor').scrollIntoView({
          behavior: 'smooth'
        })
      }
    }
  }

  const validateValues = (inputValues) => {
    let errors: {
      name?: string
      email?: string
      phone?: string
      message?: string
      termsConsent?: string
      captcha?: string
    } = {}

    if (inputValues.name.length < 2) {
      errors.name = 'Missing name.'
    }
    if (!inputValues.email.match(/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/)) {
      errors.email = 'Error email address.'
    }
    if (inputValues.phone.length < 6) {
      errors.phone = 'Please provide your phone number.'
    }
    if (inputValues.message.length < 15) {
      errors.message = 'Message should be at least 15 characters long.'
    }
    if (!isChecked) {
      errors.termsConsent = 'Please agree with the terms of use.'
    }
    if (!validateCaptcha(inputValues.captcha)) {
      errors.captcha = 'Please provide captcha code.'
    }
    return errors
  }

  const handleChange = (e) => {
    e.target.name !== 'termsConsent' ?
      setInputFields({ ...inputFields, [e.target.name]: e.target.value })
      :
      setInputFields({ ...inputFields, termsConsent: !inputFields.termsConsent })
  }
  const handleChceckbox = (e) => {
    setIsChecked(!isChecked)
  }

  const handleSubmit = (event) => {
    event.preventDefault()
    setErrors(validateValues(inputFields))
    setSubmitting(true)
  }

  return (
    <>
      <div className="contact-form form-holder" id="js-scroll-anchor">
        <form onSubmit={handleSubmit} id="contact-form">
          <div className="form-group form-group-inline">
            <label htmlFor="name">Name *
              <input
                type="text"
                id="name"
                name="name"
                value={inputFields.name}
                onChange={handleChange}
                autoComplete={'one-time-code'}
              /></label>
            {errors.hasOwnProperty('name') && (
              <FormError errorString='Please provide your name.' />
            )}
          </div>
          <div className="form-group form-group-inline">
            <label htmlFor="email">Email *
              <input
                type="text"
                id="email"
                name="email"
                value={inputFields.email}
                onChange={handleChange}
                autoComplete={'one-time-code'}
              /></label>
            {errors.hasOwnProperty('email') && (
              <FormError errorString='Please provide your valid email address.' />
            )}
          </div>
          <div className="form-group form-group-inline">
            <label htmlFor="phone">Phone number *
              <input
                type="text"
                id="phone"
                name="phone"
                value={inputFields.phone}
                onChange={handleChange}
                autoComplete={'one-time-code'}
              /></label>
            {errors.hasOwnProperty('phone') && (
              <FormError errorString='Please provide your phone number.' />
            )}
          </div>
          <div className="form-group form-group-inline">
            <label htmlFor="city">City
              <input
                type="text"
                id="city"
                name="city"
                value={inputFields.city}
                onChange={handleChange}
                autoComplete={'one-time-code'}
              /></label>
          </div>
          <div className="form-group">
            <label htmlFor="message">Message *
              <textarea
                id="message"
                name="message"
                rows={3}
                value={inputFields.message}
                onChange={handleChange}
                autoComplete={'one-time-code'}
              ></textarea></label>
            {errors.hasOwnProperty('message') && (
              <FormError errorString='Message should be at least 15 characters.' />
            )}
          </div>
          <div className="form-group form-group-inline">
            <label htmlFor="captcha">Captcha code *
              <input
                type="text"
                id="captcha"
                name="captcha"
                value={inputFields.captcha}
                onChange={handleChange}
                autoComplete={'one-time-code'}
              /></label>
            {errors.hasOwnProperty('captcha') && (
              <FormError errorString='Please retype captcha code.' />
            )}
          </div>
          <div className="form-group">
            <LoadCanvasTemplate />
          </div>

          <div className="form-group terms">
            <label htmlFor="terms-consent" className="focus-exception">
              <input
                type="checkbox"
                id="terms-consent"
                name="termsConsent"
                onChange={handleChange}
                onClick={handleChceckbox}
                checked={isChecked}
              /> Please tick to confirm you have read and agreed our privacy policy below.
            </label>
            {errors.hasOwnProperty('termsConsent') && (
              <FormError errorString='Please agree with terms of use.' />
            )}
          </div>

          <div className="form-group">
            {/*<button type='submit' className="button">{submitButton}</button>*/}
            <button type='submit' className="button" disabled={submitting}>
              {submitting ? <div className='spinner'></div> : submitButton}
            </button>
          </div>
        </form>
      </div>
    </>
  )
}

export default ContactForm